import { ARTICOLI, SLUG } from 'utils/endpoint'
import { ARTICOLO, LEZIONE, api } from 'utils'

import ArticoloHead from 'components/ArticoloHead'
import Error from 'next/error'
import PdfLayout from 'components/layout/PdfLayout'
import Pills from 'components/atomic/Pills'
import PlaceholderReact from 'components/atomic/PlaceholderReact'
import { useState } from 'react'
import React from 'react'
import { api as pagebuilderApi } from 'react-pagebuilder/services/api'

const ArticoloDetailPdf = ({ item, newContent, newIntro, statusCode }) => {
  if (!item) return <Error statusCode={statusCode} />

  const [articolo, setArticolo] = useState(item)
  const classLezione = articolo.tipologia === LEZIONE ? 'articolo-page__lezione' : ''
  let contentClass = 'articolo-page__content col '

  return (
    <>
      {articolo ? (
        <>
          <style jsx>{`
            * {
              text-rendering: geometricprecision !important;
            }
          `}</style>
          <main className="articolo-page">
            <div className={classLezione}>
              <div className="w-container-inner">
                <header className="articolo-page__header">
                  <ArticoloHead articolo={articolo} />
                </header>
                {articolo.tipologia === LEZIONE ? (
                  <PlaceholderReact
                    contentTypeId={articolo.model}
                    objectId={articolo.id}
                    pkey="intro"
                    serverSideContent={newIntro}
                  />
                ) : null}
              </div>
            </div>

            <div className="w-container-inner">
              <div className="row">
                <section className={contentClass}>
                  {articolo.tipologia === ARTICOLO && articolo.main_image ? (
                    <img
                      className="articolo-page__content__main-image"
                      src={articolo.main_image}
                      alt={articolo.titolo}
                    />
                  ) : null}

                  {articolo.testo ? (
                    <div
                      className="custom-content"
                      dangerouslySetInnerHTML={{ __html: articolo.testo }}
                    />
                  ) : (
                    <PlaceholderReact
                      contentTypeId={articolo.model}
                      objectId={articolo.id}
                      pkey="content"
                      serverSideContent={newContent}
                    />
                  )}

                  <Pills tassonomia={articolo.tassonomia} />
                </section>
              </div>
            </div>
          </main>
        </>
      ) : null}
    </>
  )
}

export const getServerSideProps = async ({ query: { slug }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${ARTICOLI}${SLUG}${slug}/`, {
      params: { is_pdf: true },
      headers,
    })
    const item = response.data

    const newContent = await pagebuilderApi.getPagebuilder({
      contentTypeId: item.model,
      objectId: item.id,
      key: 'content',
      edit_mode: false,
      isPdf: true,
    })

    let newIntro = null
    if (item.tipologia === LEZIONE) {
      newIntro = await pagebuilderApi.getPagebuilder({
        contentTypeId: item.model,
        objectId: item.id,
        key: 'intro',
        edit_mode: false,
        isPdf: true,
      })
    }

    return { props: { item, newContent, newIntro, key: item.id } }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

ArticoloDetailPdf.Layout = PdfLayout

export default ArticoloDetailPdf
